import { createContext } from "react";

export const PedidosHistorialDetalleContext = createContext()
export const PedidosHistorialDetalleReportContext = createContext()